import React from "react";
import { Link } from "react-router-dom";

//Components
import NavbarGroup from "../components/navbarGroup";
import TicketAllocTable from "../components/ticketAllocTable";
import SearchBox from "../components/common/searchBox";
import withMyHook from "../components/common/withMyHook";

//Other
import _ from "lodash";
import { ToastContainer, Zoom } from "react-toastify";
import { ArrowLeftCircle, PlusCircle } from "react-bootstrap-icons";

//Services
import httpService from "./../services/httpService.js";
import config from "../config.json";

class pageTicketAllocation extends React.Component {
  state = {
    dataRetreived: [],
    entityName: "",
    groupName: "",
    groupID: "",
    raceID: "",
    raceNameYear: "",

    searchQuery: "",
    sortColumn: { path: "raceDesc", order: "asc" },

    myParams: this.props.myParams,
    myNavigate: this.props.myNavigate,
  };

  async componentDidMount() {
    //  This will be the entity id
    // get entity detaisl and set local info
    const ID = this.state.myParams.id;
    console.log("ID = " + ID);

    const groupName = localStorage.getItem("groupName");
    const groupID = localStorage.getItem("groupID");
    const raceNameYear = localStorage.getItem("raceNameYear");
    const raceID = localStorage.getItem("raceID");

    // Set the Entity id in the local Storage
    if (ID === "") return;
    let { data: entity } = await httpService.get(
      config.apiEndpointEntityGet + "?id=" + ID
    );
    const retreivedEntityName = entity.entityName;

    // Set the Entity id in the local Storage
    localStorage.setItem("entityID", ID);
    localStorage.setItem("entityName", retreivedEntityName);

    this.setState({
      groupName,
      groupID,
      raceID,
      raceNameYear,
      entityName: retreivedEntityName,
    });

    // if the race Id has been passed in addition to the entity id
    if (ID) {
      // Get data by entity ID and race ID
      let { data: Dbdata } = await httpService.get(
        config.apiEndpointEntityTicektAllocatedGet +
          "?entityID=" +
          ID +
          "&" +
          "raceID=" +
          raceID
      );
      this.setState({ dataRetreived: Dbdata });
    }
  }

  handleSort = (sortColumn) => {
    this.setState({ sortColumn: sortColumn });
  };

  handleSearch = (query) => {
    this.setState({
      searchQuery: query,
      currentPage: 1,
    });
  };

  render() {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    let { dataRetreived, entityName, searchQuery, sortColumn } = this.state;

    const sortedData = _.orderBy(
      dataRetreived,
      [sortColumn.path],
      [sortColumn.order]
    );

    // filter the data from search input contents

    let filtered = sortedData;
    if (searchQuery)
      filtered = sortedData.filter((m) =>
        m.raceDesc.toLowerCase().startsWith(searchQuery.toLowerCase())
      );

    const allEntriesTotal = filtered.length;

    return (
      <React.Fragment>
        <ToastContainer
          draggable={true}
          transition={Zoom}
          autoClose={2000}
          position="top-center"
        />
        <NavbarGroup />

        <div className="container container-top-70">
          <div className="row">
            <h5>{entityName} - Ticket Allocation</h5>
            <div className="col" data-aos="fade-right">
              <span className="button-padding">
                <Link
                  to={`/pageEntityTicketAlloc/${this.state.raceID}`}
                  className="btn p-0"
                >
                  <ArrowLeftCircle color="#002072" size={40} />
                </Link>{" "}
                <Link
                  to="/ticketTypeEntityAllocationForm/new"
                  className="btn p-0"
                >
                  <PlusCircle color="#002072" size={40} />
                </Link>
              </span>
            </div>
            <div className=" col searchBar-width-300" data-aos="fade-left">
              <SearchBox
                value={searchQuery}
                onChange={this.handleSearch}
                placeholder="Search Ticket Allocations..."
              />
            </div>
          </div>

          <div className="row">
            <div
              className="col table-top-padding"
              data-aos="zoom-in"
              data-aos-duration="5000"
            >
              <TicketAllocTable
                filtereddata={filtered}
                onSort={this.handleSort}
                sortColumn={sortColumn}
                allEntriesTotal={allEntriesTotal}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withMyHook(pageTicketAllocation);
